import * as React from 'react';
import * as style from './FixedBlock.css';

export interface IFixedBlockProps {
  dataMark?: string;
  tag?: 'div' | 'section' | 'p' | 'span';
  top?: number | string;
  bottom?: number | string;
  left?: number | string;
  right?: number | string;
  children: React.ReactNode;
}

export const FixedBlock = (props: IFixedBlockProps) => {
  const {
    tag: Tag = 'div',
    dataMark = 'FixedBlock',
    children,
    top = 0,
    bottom = 'auto',
    left = 0,
    right = 'auto',
  } = props;

  return (
    <Tag
      style={{
        top,
        bottom,
        left,
        right,
      }}
      data-mark={dataMark}
      className={style['layout']}
    >
      {children}
    </Tag>
  );
};
